/**
 * Umbraco Forms validation message patch
 *
 * Umbraco Forms 17 has a bug where existing fields don't pick up the
 * DefaultRequiredErrorMessage from appsettings. This patches any empty
 * data-val-required attributes with a default message derived from the
 * field label.
 *
 * Uses a MutationObserver so it also catches forms rendered dynamically
 * by Vue or loaded via AJAX.
 */
function patchEmptyValidationMessages(root) {
  const els = (root || document).querySelectorAll('[data-val-required]');
  els.forEach(function (el) {
    if (!el.getAttribute('data-val-required')) {
      const label = el
        .closest('.umbraco-forms-field')
        ?.querySelector('.umbraco-forms-label');
      const name = label
        ? label.textContent.replace(/\s*\*\s*$/, '').trim()
        : 'this field';
      el.setAttribute('data-val-required', 'Please provide a value for ' + name);
    }
  });
}

// Run on initial load
patchEmptyValidationMessages();

// Watch for dynamically added forms (Vue rendering, AJAX, etc.)
const observer = new MutationObserver(function (mutations) {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        patchEmptyValidationMessages(node);
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
